"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PhilosophyFounders() {
  const {
    ref: titleRef
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: bullet1Ref
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: bullet2Ref
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: bullet3Ref
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="philosophy-founders"
  // Mobile: standard padding | Desktop: your specific 96px/128px padding
  className="bg-primary px-6 py-16 lg:![padding:96px_24px_128px_24px]">
      <div className="container mx-auto">
        {/* Grid: 1 column on mobile, 2 columns on desktop */}
        <div className="grid grid-cols-1 gap-12 items-start lg:grid-cols-2 lg:gap-16 xl:gap-24 lg:![margin:0px_50px_0px_50px]">
          
          <div className="space-y-8">
            <div>
              <p className="text-[14px] font-medium uppercase tracking-widest mb-4 !text-[hsl(32,29%,42%)]">
                ABOUT US
              </p>
              <h2 ref={titleRef} className="font-display font-bold text-foreground leading-tight transition-all duration-700 opacity-100 translate-y-0 text-4xl lg:!text-5xl">
                Crafting Refined Spaces with Experience and Integrity
              </h2>
            </div>

            <div ref={textRef} className="flex gap-4 transition-all duration-700 delay-300 opacity-100 translate-x-0 !items-center"></div>

            <div className="space-y-4 mt-8">
              {/* Bullet 1 */}
              <div ref={bullet1Ref} className="flex gap-4 transition-all duration-700 delay-200 opacity-100 translate-x-0 !items-center lg:![margin:-30px_0px_16px_0px]">
                <div className="relative flex-1">
                  <div className="absolute left-0 top-0 h-full w-0.5 origin-top transition-transform duration-700 scale-y-100 !bg-[hsl(7,64%,38%)]" style={{
                  transitionDelay: "300ms"
                }} />
                  <p className="text-foreground pl-4 py-1 lg:![padding:0px_0px_0px_16px] lg:![margin:10px_0px_10px_0px]">
                    Founded in 2020, KS LUXURY RENOVATIONS is a boutique renovation and design & build company based in Limassol, Cyprus.
                  </p>
                </div>
              </div>

              {/* Bullet 2 */}
              <div ref={bullet2Ref} className="flex gap-4 transition-all duration-700 delay-300 opacity-100 translate-x-0 !items-center">
                <div className="relative flex-1">
                  <div className="absolute left-0 top-0 h-full w-0.5 origin-top transition-transform duration-700 scale-y-100 !bg-[hsl(7,64%,38%)]" style={{
                  transitionDelay: "400ms"
                }} />
                  <p className="text-foreground pl-4 py-1 lg:![margin:10px_0px_10px_0px]">
                    Our work is driven by experience, precision, and a deep understanding of what luxury truly means — timeless quality, thoughtful design, and flawless execution.
                  </p>
                </div>
              </div>

              {/* Bullet 3 */}
              <div ref={bullet3Ref} className="flex gap-4 transition-all duration-700 delay-500 opacity-100 translate-x-0 !items-center">
                <div className="relative flex-1">
                  <div className="absolute left-0 top-0 h-full w-0.5 origin-top transition-transform duration-700 scale-y-100 !bg-[hsl(7,64%,38%)]" style={{
                  transitionDelay: "500ms"
                }} />
                  <p className="text-foreground pl-4 py-1 lg:![margin:10px_0px_10px_0px]">
                    We specialise in high-end residential renovations and premium commercial projects, delivering results that feel considered, balanced, and enduring.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column (Image) */}
          <div className="w-full flex justify-center lg:justify-end lg:justify-self-end">
            <div className="overflow-hidden rounded-xl w-full max-w-[600px]">
              <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/contemporary_office_lobby.webp" alt="Founder Portrait One" className="w-full h-auto object-cover transition-transform duration-700 ease-in-out hover:scale-110 lg:ml-auto lg:w-[600px]" />
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}